import moment from "moment/moment";
import {mapGetters} from "vuex";
import {getDynamicFilterLabel} from "@/utils/dictionary";
import {getInputType} from "@/utils/forms";

export default {
    data() {
        return {
            open_filter: false,
            typologies: [
                {value: "0,1,2", text: "Polizze attive"},
                {value: "3,4,5,6,7,8,9,10,11", text: "Polizze estinte"},
            ],
            paths_set_to_false: [
                "/bank-accounts",
                "/profile-companies-products",
                "/profile-sectors",
                "/profile-treasuries",
                "/profile-various-accounting",
                "/profile-brokers",
                "/profile-cooperators",
                "/insurer_participants",
                "/profile-import-maps",
                "/book-tags",
                "/custom-attributes-create",
                "/treasury-cash-reference",
                "/report",
                "/communication-procedures",
                "/lisacomunica",
                "/lisacomunica-logs",
                "/users",
            ],
            paths_additional_filters: ["/book-entries", "/insurance-payments"],
            activeFilters: {},
            salesmen: [],
            context: "",
            products: [],
            cooperators: [],
            treasuries: [],
            payment_references: [],
            sectors: [],
            selectOptions: [
                {text: "Si", value: "Y"},
                {text: "No", value: "N"},
            ],
            byExclutionOptions: [
                {text: "Si", value: true},
                {text: "No", value: false},
            ],
            registered: [
                {text: "Si", value: 1},
                {text: "No", value: 0},
            ],
            bank_accounts: [],
            book_tags_opt: [],
            treasuries_opt: [],
            cash_references: [],
            agency_brokers: [],
            foglio_cassa_compagnia: [
                {value: "1", text: "Si"},
                {value: "0", text: "No"},
            ],
            cassa_agenzia: [
                {value: "1", text: "Si"},
                {value: "0", text: "No"},
            ],
            various_accounting_not_system_options: [],
            mandate_code_options: [],
            to_collect_options: [
                {value: "Y", text: "Si"},
                {value: "N", text: "No"},
            ],
            relatedNotesOptions: [
                {value: "Y", text: "Elenca solo quietanze con note associate"},
            ],
            discardedOptions: [
                {text: "SI", value: "Y"},
                {text: "NO", value: "N"},
            ],
            pagamenti: [{value: "0", text: "solo da incassare"}],
            comments: [{value: "!", text: "solo commentate"}],
            contraenti: [{value: "byMostInExpiry", text: "solo con più scadenze"}],
            modificate: [{value: "Y", text: "solo modificate"}],
            opt_insurer_participant: [{text: "Tutti", value: "!0"}],
            opt_is_selected: [
                { value: 'Y', text: 'Si' },
                { value: 'N', text: 'No' },
            ],
            documentTypeOptions: [
                {value: 0, text: "Privacy"},
                {value: 1, text: "Generico"},
                {value: 2, text: "Documento di Identità"},
            ],
            error_codes: [
                {value: '0', text: 'Discordanza data'},
                {value: '1', text: 'Polizza Annullata'},
                {value: '2', text: 'Polizza disdetta'},
                {value: '3', text: 'Polizza non perfezionata'},
                {value: '4', text: 'Polizza senza tacito rinnovo'},
                {value: '5', text: 'Polizza sospesa'},
                {value: '6', text: 'Polizza stornata'},
                {value: '7', text: 'Polizza sostituita'},
                {value: '10', text: 'Polizza Trasferita'},
                {value: '8', text: 'Quietanza pagata'},
                {value: '9', text: 'Rata precedente non incassata'},
            ],
            status: [
                {value: "FAILED", text: "Fallito"},
                {value: "SENDING", text: "Invio in corso"},
                {value: "OK", text: "Completato"},
                {value: "SCHEDULED", text: "Programmato"},
            ],
            types: [
                {value: "SMS", text: "SMS"},
                {value: "EMAIL", text: "Email"},
                {value: "PDF", text: "Pdf"},
            ],
            sent: [
                {value: "Y", text: "Si"},
                {value: "N", text: "No"},
            ],
            selected: [
                {value: "Y", text: "Si"},
                {value: "N", text: "No"},
            ],
            typeOptions: [
                {text: "Email", value: 0},
                {text: "SMS", value: 2},
                // { text: "Stampa", value: 3 },
            ],
            stato_lisapay: [
                {value: 0, text: "Non Pagato"},
                {value: 1, text: "Pagato"},
            ],
            iban_options: [
                {value: "Y", text: "Si"},
                {value: "N", text: "No"},
            ],
            configurable_type: [
                {
                    value: "variousAccounting",
                    text: "Causale contabile movimenti vari",
                },
                {value: "insurer", text: "Compagnia"},
                {value: "sector", text: "Comparto contabile"},
                {value: "broker", text: "Produttore"},
            ],
            payment_types: [
                {value: 2, text: "Quietanze"},
                {value: 0, text: "Sospesi"},
                {value: 1, text: "Titoli arretrati"},
                {value: 3, text: "Acconti"},
                {value: 4, text: "Manuale"},
            ],
            movimenti: [
                {value: "0", text: "Versamento"},
                {value: "1", text: "Prelievo"},
                {value: "3", text: "Giroconto"},
            ],
            opt_incassato: [
                {value: "Y", text: "Si"},
                {value: "N", text: "No"},
            ],
            opt_broker_statement: [
                {value: "!0", text: "Rendicontato"},
                {value: "!", text: "Non rendicontato"},
            ],
            tipo_anagrafica: [
                {value: 0, text: "Persona Fisica"},
                {value: 1, text: "Persona Giuridica"},
            ],
            deferred: [
                {value: "yes", text: "Aperti e parzialmente aperti"},
                {value: "no", text: "Chiusi e parzialmente recuperati"},
                {value: "reduced", text: "Parzialmente aperti"},
                {value: "tutti", text: "Tutti"},
                {value: "aperti", text: "Aperti"},
                {value: "aperti-parziali", text: "Aperti e parzialmente recuperati"},
                {value: "chiusi", text: "Chiusi"},
                {value: "chiusi-parziali", text: "Chiusi e parzialmente incassati"},
            ],
            exclusion_types: [
                {
                    value: 0,
                    text: "Escluso",
                },
                {
                    value: 1,
                    text: "In partenza",
                },
            ],
            deposit: [
                {value: "both", text: "Tutti"},
                {value: "yes", text: "Aperti e parzialmente aperti"},
                {value: "no", text: "Chiusi e parzialmente recuperati"},
                {value: "reduced", text: "Parzialmente aperti"},
            ],
            delega: [
                {value: "0", text: "Delega Nostra"},
                {value: "1", text: "Delega Altrui"},
            ],
            titoli: [
                {value: "0", text: "Da incassare"},
                {value: "1", text: "Incassato"},
                {value: "2", text: "Stornati"},
                {value: "3", text: "Annullati manualmente"},
                {value: "4", text: "Annullati manualmente + annullo polizza"},
                {value: "5", text: "Annullati su piattaforma compagnia"},
                {value: "6", text: "Annullati per sostituzione"},
                {value: "7", text: "Da validare"},
            ],
            transmission_status_options: [
                {value: -1, text: "Errore"},
                {value: 0, text: "Creato"},
                {value: 1, text: "Pronto per la trasmissione"},
                {value: 2, text: "In corso"},
                {value: 3, text: "Completato"},
                {value: 4, text: "Completato con errori"},
                {value: 5, text: "In coda"},
                {value: 6, text: "Caricamento dati"},
            ],
            fattutto_records_options: [
                {value: 0, text: "No"},
                {value: 1, text: "Si"},
            ],
            opt_provinces: [],
            opt_councils: [],
            policies_with_notes: [
                {value: "2", text: "Cerca solo polizze con note"},
            ],
            tipo_titoli: [
                {value: "P", text: "Polizze"},
                {value: "Q", text: "Quietanze"},
                {value: "A", text: "Appendici"},
                // { value: "X", text: "Pregresso" },
            ],
            status_payment_options: [
                {value: "0", text: "Aperto"},
                {value: "1", text: "Usato"},
            ],
            insurance_payments_status_payments: [
                {value: "0", text: "Valido"},
                {value: "1", text: "Da Validare"},
                {value: "2", text: "Mancante"},
                {value: "3", text: "Incassato"},
                {value: "4", text: "Annullato/Stornato"},
            ],
            opt_sup_cli: [
                {text: "Si", value: "Y"},
                {text: "No", value: "N"},
            ],
            statusOptions: [
                {text: "Inizio", value: 0},
                {text: "Esclusioni", value: 1},
                {text: "Raggruppamenti", value: 2},
                {text: "Modifica", value: 3},
                {text: "Template", value: 4},
                {text: "Invio", value: 5},
            ],
            lastInstallmentOptions: [
                {value: "yes", text: "Solo in scadenza di contratto"},
                {value: "no", text: "Solo scadenze intermedie"},
            ],
            payment_splitting: [
                {value: "0", text: "Unico"},
                {value: "1", text: "Mensile"},
                {value: "2", text: "Bimestrale"},
                {value: "3", text: "Trimestrale"},
                {value: "4", text: "Quadrimestrale"},
                {value: "6", text: "Semestrale"},
                {value: "12", text: "Annuale"},
            ],
            communication_channel: [
                { value: '0', text: 'E-mail' },
                { value: '1', text: 'Posta' },
                { value: '2', text: 'SMS' },
                { value: '3', text: 'Telefono' },
                { value: '4', text: 'No Avviso' },
                { value: '5', text: 'Tramite Capo Gruppo' },
                { value: 'default', text: 'Canale di default' },
            ],
            empty_contact: [
                { value: 'mail', text: 'Email' },
                { value: 'cell', text: 'Cellulare' },
                { value: 'mail,cell', text: 'Email e cellulare' },
            ],
            status_policy: [
                {value: "0", text: "Non perfezionata"},
                {value: "1", text: "Perfezionata"},
                {value: "2", text: "Sospesa"},
                {value: "3", text: "Sostituita"},
                {value: "10", text: "Stornata"},
                {value: "4", text: "Annullata"},
                {value: "5", text: "Scaduta"},
                {value: "6", text: "Svincolata"},
                {value: "7", text: "Abbandonata"},
                {value: "8", text: "Disdetta"},
                {value: "9", text: "Nuova viva"},
                {value: "11", text: "Trasferita"},
            ],
            opt_status: [
                {value: "expired", text: "Scaduti"},
                {value: "last_day", text: "Ultimo giorno di mora"},
                {value: "ending", text: "In scadenza"},
                {value: "valid", text: "Validi"},
            ],
            opt_customers: [
                {text: "Cliente", value: "Y"},
                {text: "Fornitore", value: "N"},
            ],
            form: {
                inpt_label_policy: "",
                inpt_label_group: "",
                input_label_registry: "",
            },
            companies: [],
            opt_suppliers: [],
            surveyor: null,
            risks: [],
            settled_options: [
                {value: "yes", text: "Si"},
                {value: "no", text: "No"},
            ],
            indx: [{value: "Y", text: "Si"}],
            bona: [{value: "Y", text: "Si"}],
            consenso: [
                {value: "yes", text: "Si"},
                {value: "no", text: "No"},
            ],
            opt_anagrafiche_lisaweb: [{value: "0", text: "Si"}],
            statusInsuranceOptions: [],
        };
    },
    methods: {
        sidebarFilterName(name, context) {
            if (!name) return "-";
            const result = this.getDictionary(name, `filters`, context);
            if (result) return result;
            return getDynamicFilterLabel(name, this.customFilters) || result;
        },
        sidebarFilterValue(name, value) {
            console.log("NAME", name, "VALUE", value);

            const formattingDayMonthYearDate = (value) => {
                if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
                    return moment(value).format("DD/MM/YYYY");
                }
                return value;
            };

            const formattingMonthYearDate = (value) => {
                let [year, month] = value.split("/");
                month = month.padStart(2, "0");
                return `${month}/${year}`;
            };

            const findOptionText = (options, val) => {
                const found = (options || []).find((el) => String(el.value) === String(val));
                return found ? found.text : val;
            };

            let ret;
            try {
            switch (name) {
                case "byTypology.status_policy":
                    ret = findOptionText(this.typologies, value);
                    break;
                case "byBroker.id":
                case "byCommissionApplied.id":
                case "byBrokerEnhanced.salesmen":
                    ret = findOptionText(this.salesmen, value);
                    break;
                case "byPaymentReference.id":
                    ret = findOptionText(this.payment_references, value);
                    break;
                case "produttore":
                    ret = findOptionText(this.salesmen, value);
                    break;
                case "byAttribute.setup_at._i":
                    ret = formattingMonthYearDate(value);
                    break;
                case "byCalendar.to._i":
                    ret = formattingMonthYearDate(value);
                    break;
                case "byAttribute.payment_splitting":
                case "byInsurancePolicy.payment_splitting":
                    ret = findOptionText(this.payment_splitting, value);
                    break;
                /* Sui titoli sono colonne proprie, sulle quietanze si passa dalla relazione */
                case "byAttribute.to_collect":
                case "byInsuranceAncillary.to_collect":
                case "byAttribute.consolidated":
                case "byInsuranceAncillary.consolidated":
                    ret = findOptionText(this.to_collect_options, value);
                    break;
                case "byAttribute.is_selected":
                    ret = findOptionText(this.opt_is_selected, value);
                    break;
                case "byAttribute.error_code":
                    ret = findOptionText(this.error_codes, value);
                    break;
                case "byCommunicationDetail.is_discarded":
                    ret = findOptionText(this.discardedOptions, value);
                    break;
                case "bySettled":
                    ret = findOptionText(this.settled_options, value);
                    break;
                case "byExclusion":
                    ret = findOptionText(this.byExclutionOptions, value);
                    break;
                case "status":
                    ret = findOptionText(this.status, value);
                    break;
                case "type":
                    ret = findOptionText(this.types, value);
                    break;
                case "byRelations":
                    ret = findOptionText(this.contraenti, value);
                    break;
                case "conto":
                    ret = findOptionText(this.treasuries_opt, value);
                    break;
                case "compagnia":
                case "byInsurer.id":
                    ret = findOptionText(this.companies, value);
                    break;
                case "byAttribute.status_policy":
                    ret = findOptionText(this.status_policy, value);
                    break;
                case "byTaskable":
                    ret = findOptionText(this.taskableTypeOptions, value);
                    break;
                case "byAttribute.document_type":
                    ret = findOptionText(this.documentTypeOptions, value);
                    break;
                case "byAttribute.exclusion_type":
                    ret = findOptionText(this.exclusion_types, value);
                    break;
                case "byBankAccount":
                    ret = findOptionText(this.iban_options, value);
                    break;
                case "configurable_type":
                    ret = findOptionText(this.configurable_type, value);
                    break;
                case "byBankAccount.id":
                    ret = findOptionText(this.bank_accounts, value);
                    break;
                case "byAttribute.sent":
                    ret = findOptionText(this.sent, value);
                    break;
                case "byAttribute.status_procedure":
                    ret = findOptionText(this.statusOptions, value);
                    break;
                case "least_one_to_go":
                    ret = findOptionText(this.fattutto_records_options, value);
                    break;
                case "transmission_status":
                    ret = findOptionText(this.transmission_status_options, value);
                    break;
                case "byCustom.selected":
                    ret = findOptionText(this.selected, value);
                    break;
                case "byAttribute.communication_type":
                    ret = findOptionText(this.typeOptions, value);
                    break;
                case "byInsuranceAncillary.status_ancillary":
                    ret = findOptionText(this.pagamenti, value);
                    break;
                case "byAttribute.registered":
                    ret = findOptionText(this.registered, value);
                    break;
                case "byAttribute.modified":
                    ret = findOptionText(this.modificate, value);
                    break;
                case "byRegistry.status_registry":
                case "byAttribute.status_registry":
                    ret = findOptionText(this.tipo_anagrafica, value);
                    break;
                case "byRelatedTasks":
                    ret = findOptionText(this.relatedNotesOptions, value);
                    break;
                case "byAttribute.CUST3":
                    ret = findOptionText(this.selectOptions, value);
                    break;
                case "byLastInstallment":
                    ret = findOptionText(this.lastInstallmentOptions, value);
                    break;
                case "byRiskType.id":
                    ret = findOptionText(this.risks, value);
                    break;
                case "byRiskBranch.id":
                    ret = findOptionText(this.risk_branches, value);
                    break;
                case "byInsuranceRisk.id":
                    ret = findOptionText(this.prdct, value);
                    break;
                case "byCollaborator.id":
                    ret = findOptionText(this.cooperators, value);
                    break;
                case "causale":
                    ret = findOptionText(this.cash_references, value);
                    break;
                case "byBrokerGroup.id":
                    ret = findOptionText(this.agency_brokers, value);
                    break;
                case "byAttribute.code":
                    ret = findOptionText(this.tipo_titoli, value);
                    break;
                case "byAttribute.payment_type":
                    ret = findOptionText(this.payment_types, value);
                    break;
                case "byAttribute.comment":
                    ret = findOptionText(this.comments, value);
                    break;
                case "byStocastico.status":
                    ret = findOptionText(this.opt_status, value);
                    break;
                case "byCommunicationChannel":
                    ret = findOptionText(this.communication_channel, value);
                    break;
                case "byEmptyContact":
                    ret = findOptionText(this.empty_contact, value);
                    break;
                case "byAttribute.mandate_code_id":
                    ret = findOptionText(this.mandate_code_options, value);
                    break;
                case "byImport":
                    if (value === "broker" || value === "treasury") {
                        ret = "No";
                    } else if (value === "broker2" || value === "treasury2") {
                        ret = "Si";
                    } else {
                        ret = "";
                    }
                    break;
                case "byBookTag.id":
                    ret = findOptionText(this.book_tags_opt, value);
                    break;
                case "byStatementAnomaly":
                    ret = "Si";
                    break;
                case "byExpiration.from":
                case "byExpiration.to":
                case "byCoverage.from":
                case "byCoverage.to":
                case "byValidity.from":
                case "byValidity.to":
                case "byIssue.from":
                case "byIssue.to":
                case "bySuspension.from":
                case "bySuspension.to":
                case "byCancellation.from":
                case "byCancellation.to":
                case "byEffectiveness.from":
                case "byEffectiveness.to":
                case "byCalendar.from":
                case "byCalendar.to":
                case "start":
                case "end":
                case "bySheetDate.from":
                case "bySheetDate.to":
                case "byDetailDate.from":
                case "byDetailDate.to":
                case "byOccurrence.date":
                case "byStocastico.date":
                case "byAttribute.imported_at":
                case "byAttribute.sheet_date":
                case "byAttribute.sheet_number":
                case "byReduced.before_deferred":
                case "byReduced.after_deferred":
                case "byCustom.lisapay_paid_at.value":
                case "byCustom.paid_at.value":
                case "data_registrazione_inizio":
                case "data_registrazione_fine":
                case "data_recupero_inizio":
                case "data_recupero_fine":
                case "a_partire_dal":
                case "fino_al":
                case "date_from":
                case "date_to":
                case "byFrom.from":
                case "byFrom.to":
                case "byTo.from":
                case "byTo.to":
                case "byDelayUntil.from":
                case "byDelayUntil.to":
                case "byLisapayPaidAt.to":
                case "byLisapayPaidAt.from":
                case "byPaidAt.from":
                case "byPaidAt.to":
                case "byReduced.before_recovery":
                case "byReduced.after_recovery":
                    ret = formattingDayMonthYearDate(value);
                    break;
                case "byCurrency.from":
                case "byCurrency.to":
                case "byNet.from":
                case "byNet.to":
                    ret = `${value}€`;
                    break;
                case "byAttribute.BONA":
                    ret = findOptionText(this.bona, value);
                    break;
                case "byAttribute.INDX":
                    ret = findOptionText(this.indx, value);
                    break;
                case "byAttribute.CLI":
                    ret = findOptionText(this.opt_sup_cli, value);
                    break;
                case "byAttribute.GDPR":
                    ret = findOptionText(this.consenso, value);
                    break;
                case "byAttribute.SUP":
                    ret = findOptionText(this.opt_sup_cli, value);
                    break;
                case "byTask.task_type":
                    ret = findOptionText(this.policies_with_notes, value);
                    break;
                case "byBrokerStatement.id":
                    ret = findOptionText(this.opt_broker_statement, value);
                    break;
                case "byDeferred":
                    ret = findOptionText(this.deferred, value);
                    break;
                case "stato":
                    ret = findOptionText(this.deferred, value);
                    break;
                case "byAttribute.paid":
                case "byAttribute.lisapay_paid":
                    ret = findOptionText(this.stato_lisapay, value);
                    break;
                case "byDeposited":
                    ret = findOptionText(this.deposit, value);
                    break;
                case "byInsurancePolicy.sharing_type":
                    ret = findOptionText(this.delega, value);
                    break;
                case "byAttribute.is_collected":
                    ret = findOptionText(this.opt_incassato, value);
                    break;
                case "byAttribute.agencybook_type":
                    ret = findOptionText(this.movimenti, value);
                    break;
                case "attribute_type":
                    ret = findOptionText(this.opt_customers, value);
                    break;
                case "byAgencyContact.id":
                    ret = findOptionText(this.opt_suppliers, value);
                    break;
                case "byInsurerParticipant.id":
                    ret = findOptionText(this.opt_insurer_participant, value);
                    break;
                case "byAttribute.status_ancillary":
                    ret = findOptionText(this.titoli, value);
                    break;
                case "byAttribute.upselling":
                    ret =
                        this.upselling_options?.find((el) => el.value === value)?.text ??
                        value;
                    break;
                case "bySector.id":
                    ret = findOptionText(this.sectors, value);
                    break;
                case "byAttribute.status_payment": {
                    let sourceOptions;
                    if (this.tableIdentifier === "sesana-clienti") {
                        sourceOptions = this.status_payment_options;
                    } else if (this.tableIdentifier === "insurance-payments") {
                        sourceOptions = this.insurance_payments_status_payments;
                    } else {
                        sourceOptions = this.status_payment_options;
                    }
                    ret = findOptionText(sourceOptions, value);
                    break;
                }
                case "byBrokerEnhanced.cooperators":
                    ret = findOptionText(this.cooperators, value);
                    break;
                case "byRegistryGroup.code":
                    ret = this.form.inpt_label_group;
                    break;
                case "byInsurancePolicy.id":
                    ret = this.form.inpt_label_policy;
                    break;
                case "byTreasury.id":
                case "byReduced.treasury_deferred":
                case "byReduced.treasury_deposit":
                    ret = findOptionText(this.treasuries, value);
                    break;
                case "foglio_cassa_compagnia":
                    ret = findOptionText(this.foglio_cassa_compagnia, value);
                    break;
                case "cassa_agenzia":
                    ret = findOptionText(this.cassa_agenzia, value);
                    break;
                case "byVariousAccounting.id":
                    ret = findOptionText(this.various_accounting_not_system_options, value);
                    break;
                case "byRegistry.id":
                    ret = this.form.input_label_registry
                        ? this.form.input_label_registry.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase())
                        : "";
                    break;
                case "byClaimParty.title":
                    ret = this.counterpart;
                    break;
                case "byClaimParty.CPRGP":
                    ret = this.CPRGP;
                    break;
                case "province":
                case "byProvince.id":
                    ret = findOptionText(this.opt_provinces, value);
                    break;
                case "byManual":
                    ret = findOptionText(this.opt_anagrafiche_lisaweb, value);
                    break;
                case "byCorrespondence.CITY":
                    ret = findOptionText(this.opt_councils, value);
                    break;
                case "byInsuranceStatus.value":
                    ret = findOptionText(this.statusInsuranceOptions, value);
                    break;
                default:
                    ret = "";
                    break;
            }
            } catch (e) {
                // A filter value with no matching option (e.g. a stale value left
                // by a reset, or a typology value stored under byAttribute) would
                // otherwise throw on `.find(...).text` and break the whole render.
                // Fall back to showing the raw value instead.
                ret = value;
            }
            /* */
            if (!ret && this.customFilters?.length) {
                const byCustomMatch = name.match(/^byCustom\.(.+?)\.value$/);
                const byAttrMatch = name.match(/^byAttribute\.(.+)$/);
                const key = byCustomMatch ? byCustomMatch[1] : (byAttrMatch ? byAttrMatch[1] : null);
                if (key) {
                    const cf = this.customFilters.find(e => e.key === key);
                    if (cf) {
                        const inputType = getInputType(cf);
                        if (inputType === "datepicker") {
                            ret = formattingDayMonthYearDate(value);
                        } else if (inputType === "radio") {
                            const opt = this.selectOptions.find(o => o.value === value);
                            ret = opt ? opt.text : value;
                        } else {
                            ret = value;
                        }
                    }
                }
            }
            if (!ret && !name) return "-";
            if (ret) return ret;
            ret = this.getDictionary(`${name}.${value}`, "filters");
            return ret ? ret : value;
        },
        resetSingleSidebarFilter(name) {
            // debugger;
            let res = true;
            // Split the string into parts by the `dot`
            const parts = name.split(".");

            // Traverse the allowedKeys object according to the parts
            // let currentLevel = this.filter;
            // let parentLevel = null;
            // let lastKey = null;

            // for (const part of parts) {
            //   // Check if the current part exists in the current level
            //   if (!currentLevel || !(part in currentLevel)) {
            //     res = false; // Part is not valid
            //   }
            //   parentLevel = currentLevel; // Save the current level for modification
            //   lastKey = part; // Save the current key
            //   currentLevel = currentLevel[part]; // Move to the next level
            // }

            // this.clearSingleFilter(res, parentLevel, lastKey);

            // Set the value to null at the final level
            // if (parentLevel && lastKey) {
            //   parentLevel[lastKey] = null;
            // }

            // return true; // All parts are valid

            // // Traverse the allowedKeys object according to the parts
            let currentLevel = this.filter;
            for (const part of parts) {
                // Check if the current part exists in the current level
                if (!currentLevel || !(part in currentLevel)) {
                    res = false; // Part is not valid
                }
                currentLevel = currentLevel[part]; // Move to the next level
            }
            // res = true; // All parts are valid
            if (!res) return;
            // this.clearSingleFilter(parts);
            // const splitted = this.splitByLastDot(name);
            // if (!splitted.length) return;
            this.accessNestedFilterOption(name);
            // const access = this.accessNestedFilterOption(splitted);
            // console.log(access);
            // if (!access || !Object.keys(access).length) return;
            // // debugger;
            // access[splitted[1]] = null;

            // console.log("res", res);
        },
        splitByLastDot(str) {
            const lastDotIndex = str.lastIndexOf(".");
            if (lastDotIndex === -1) {
                return [str]; // No dots found, return the whole string
            }
            return [str.slice(0, lastDotIndex), str.slice(lastDotIndex + 1)];
        },
        resetAllFilters() {
            this.onClearFilter(this.filterName);
            this.activeFilters = {};
            const table = this.tableRef ? this.$refs[this.tableRef] : null;
            if (table) {
                table.items = [];
                table.totalRows = 0;
            }
            this.open_filter = true;
        },
        setSectors() {
            const companySectors = this.getSectors().filter(
                (sector) => sector.is_agency === "N",
            );
            const systemSectors = companySectors.filter(
                (sector) => sector.is_system === "Y",
            );
            const notSystemSectors = companySectors.filter(
                (sector) => sector.is_system === "N",
            );
            this.sectors = [...notSystemSectors, ...systemSectors];
        },
        accessNestedFilterOption(name) {
            const splitted = this.splitByLastDot(name);
            if (!splitted.length) return;

            // No dot in name: top-level key, reset directly
            if (splitted.length === 1) {
                this.filter[splitted[0]] = null;
            } else {
                const access = splitted[0].split(".").reduce((o, i) => {
                    return (o && typeof o === 'object') ? o[i] : undefined;
                }, this.filter);

                if (!access || typeof access !== 'object') {
                    this.$set(this.filter, splitted[0], null);
                } else {
                    access[splitted[1]] = null;
                }
            }
            this.activeFilters = {};
            this.activeFilters = this.retriveActiveFilters();
            this.onSearch(this.filterName);
        },
        retriveActiveFilters(obj = this.filter, parentKey = "") {
            for (const key in obj) {
                const value = obj[key];
                // Build the property path (for nested properties)
                const fullPath = parentKey ? `${parentKey}.${key}` : key;

                if (key === "byCustom" && typeof value === "object") {
                    // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
                    for (const innerKey in value) {
                        const innerValue = value[innerKey];
                        if (
                            innerValue &&
                            typeof innerValue === "object" &&
                            "value" in innerValue
                        ) {
                            /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
                            if (!(innerValue.value === null || innerValue.value === "")) {
                                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                                    innerValue.value;
                            }
                        }
                    }
                } else if (value && Array.isArray(value)) {
                    if (value.length === 1) {
                        this.activeFilters[fullPath] = value[0];
                    } else if (value.length > 1) {
                        // If it's an array don't print all the values recorsively
                        this.activeFilters[fullPath] = `${value.length} selezioni`;
                    }
                } else if (value && typeof value === "object") {
                    // Recursively process nested objects for non-`byCustom` keys
                    Object.assign(
                        this.activeFilters,
                        this.retriveActiveFilters(value, fullPath),
                    );
                } else if (value !== null && String(value).length) {
                    // Append non-null values
                    this.activeFilters[fullPath] = value;
                }
            }
            return this.activeFilters;
        },
        /* */
        onSidebarFilterChange(visible) {
            console.log("Sidebar visible:", visible);

            if (visible) {
                console.log("Sidebar opened");
                this.open_filter = true;
            } else {
                console.log("Sidebar closed");
                this.open_filter = false;
            }
        },
        areActiveFiltersOnlyDefault() {
            console.log("areActiveFiltersOnlyDefault in JS");
            const currentActive = this.extractActiveFilters(this.filter);
            const defaultActive = this.extractActiveFilters(this.initFilter());
            return this.areFilterMapsEqual(currentActive, defaultActive);
        },
        extractActiveFilters(obj = this.filter, parentKey = "", out = {}) {
            console.log("extractActiveFilters in JS");
            for (const key in obj) {
                const value = obj[key];
                const fullPath = parentKey ? `${parentKey}.${key}` : key;

                if (key === "byCustom" && value && typeof value === "object") {
                    for (const innerKey in value) {
                        const innerValue = value[innerKey];
                        if (innerValue && typeof innerValue === "object" && "value" in innerValue) {
                            if (innerValue.value !== null && innerValue.value !== "") {
                                out[`${fullPath}.${innerKey}.value`] = innerValue.value;
                            }
                        }
                        // ADD THIS FALLBACK HERE TOO
                        else if (innerValue !== null && innerValue !== "") {
                            out[`${fullPath}.${innerKey}`] = innerValue;
                        }
                    }
                } else if (Array.isArray(value)) {
                    if (value.length === 1) out[fullPath] = value[0];
                    else if (value.length > 1)
                        out[fullPath] = `${value.length} selezioni`;
                } else if (value && typeof value === "object") {
                    this.extractActiveFilters(value, fullPath, out);
                } else if (value !== null && String(value).length) {
                    out[fullPath] = value;
                }
            }

            return out;
        },
        areFilterMapsEqual(a, b) {
            console.log("areFilterMapsEqual in JS");
            const aKeys = Object.keys(a).sort();
            const bKeys = Object.keys(b).sort();
            if (aKeys.length !== bKeys.length) return false;

            for (let i = 0; i < aKeys.length; i++) {
                const k = aKeys[i];
                if (k !== bKeys[i]) return false;
                if (String(a[k]) !== String(b[k])) return false;
            }
            return true;
        },
        /* */
        ...mapGetters("auth", {
            getInsurers: "insurers",
            getBranches: "branches",
            getRisks: "risks",
            getProducts: "products",
            getSalesmen: "salesmen",
            getCooperators: "cooperators",
            getMandateCodes: "mandate_codes",
            getSectors: "sectors",
            getBankAccounts: "bank_accounts",
            getPaymentReferences: "payment_references",
            getCashReferences: "cash_references",
            getAgencyBrokers: "agency_brokers",
        }),
    },
    mounted() {
        this.companies = this.getInsurers();
        this.risks = this.getRisks();
        this.salesmen = this.getSalesmen();
        this.payment_references = this.getPaymentReferences();
        this.sectors = this.getSectors();
        this.cash_references = this.getCashReferences();
        this.agency_brokers = this.getAgencyBrokers();
        // this.risk_branches = this.getBranches()(this.filter.byInsurer.id);
        this.activeFilters = {};
        this.activeFilters = this.retriveActiveFilters();
        if (!this.paths_additional_filters.includes(this?.$route?.path)) {
            this.open_filter = this.areActiveFiltersOnlyDefault();
        }
        if (this.paths_set_to_false.includes(this?.$route?.path)) {
            this.open_filter = false;
        }
    },
    computed: {
        prdct() {
            return this.products;
        },
    },
};
